import React from 'react';
import { IntlProvider, addLocaleData } from 'react-intl';
import de from 'react-intl/locale-data/de';
// eslint-disable-next-line no-restricted-imports
import fr from 'react-intl/locale-data/fr';
import { toCountry } from './models/country';
import type { Country } from './models/country';
import { toCurrency } from './models/currency';
import type { Currency } from './models/currency';
import toFormats from './models/format';
import { toLanguage } from './models/language';
import type { Language } from './models/language';
import { toLocale } from './models/locale';
import type { Locale } from './models/locale';

type Props = {
  country?: Country;
  language?: Language;
  currency?: Currency;
  locale?: Locale;
};

const Internationalize: React.FC<React.PropsWithChildren<Props & IntlProvider.Props>> = ({
  country = toCountry(),
  language = toLanguage(country),
  currency = toCurrency(country),
  locale = toLocale(language, country),
  messages,
  formats,
  ...props
}) => {
  // For non-en locales react-intl throws errors and breaks
  // if the locale isnt explicitly added
  addLocaleData(de);
  addLocaleData(fr);

  return (
    <IntlProvider
      locale={locale}
      messages={messages}
      formats={{
        ...toFormats(currency),
        ...formats,
      }}
      textComponent={React.Fragment}
      {...props}
    />
  );
};

export default Internationalize;
